var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "panel" }, [
      _vm._m(0),
      _c("div", { staticClass: "panel-body" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Họ và tên")]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", readonly: "true", placeholder: "Họ và Tên" },
            domProps: {
              value:
                _vm.customerInfo.FirstName + " " + _vm.customerInfo.LastName
            }
          })
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Địa chỉ")]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", readonly: "true", placeholder: "Địa chỉ" },
            domProps: { value: _vm.customerInfo.Address }
          })
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Email")]),
          _c("input", {
            staticClass: "form-control",
            attrs: { type: "text", readonly: "true", placeholder: "Email" },
            domProps: { value: _vm.customerInfo.Email }
          })
        ]),
        _c("div", { staticClass: "form-group" }, [
          _c("label", [_vm._v("Số điện thoại")]),
          _c("input", {
            staticClass: "form-control",
            attrs: {
              type: "text",
              readonly: "true",
              placeholder: "Số điện thoại"
            },
            domProps: {
              value:
                "(" +
                _vm.customerInfo.PhonePrefix +
                ")" +
                _vm.customerInfo.PhoneNumber
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Thông tin người đặt")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }